"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "patient-card" };
var _hoisted_2 = { class: "card-header" };
var _hoisted_3 = { class: "header-info" };
var _hoisted_4 = { class: "patient-name" };
var _hoisted_5 = { class: "mrn" };
var _hoisted_6 = { class: "card-body" };
var _hoisted_7 = {
    key: 0,
    class: "info-row"
};
var _hoisted_8 = { class: "info-text" };
var _hoisted_9 = ["href"];
var _hoisted_10 = {
    key: 1,
    class: "info-row"
};
var _hoisted_11 = { class: "info-text" };
var _hoisted_12 = ["href"];
var _hoisted_13 = {
    key: 2,
    class: "info-row"
};
var _hoisted_14 = { class: "info-text email-text" };
var _hoisted_15 = {
    key: 3,
    class: "info-row address-row"
};
var _hoisted_16 = { class: "info-text" };
var _hoisted_17 = {
    key: 4,
    class: "info-row address-row"
};
var _hoisted_18 = { class: "info-text email-text" };
var _hoisted_19 = {
    key: 5,
    class: "info-row address-row"
};
var _hoisted_20 = { class: "info-text email-text" };
var _hoisted_21 = {
    key: 6,
    class: "info-row address-row"
};
var _hoisted_22 = { class: "info-text" };
var _hoisted_23 = { class: "info-row address-row" };
var _hoisted_24 = { class: "info-text" };
var _hoisted_25 = { class: "card-footer" };
var vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TeamCard',
    props: {
        patprovider: {}
    },
    emits: ["email", "sms", "call"],
    setup: function (__props) {
        var props = __props;
        // Computed property for initials
        var initials = (0, vue_3.computed)(function () {
            var firstInitial = props.patprovider.firstName ? props.patprovider.firstName[0] : '';
            var lastInitial = props.patprovider.lastName ? props.patprovider.lastName[0] : '';
            return "".concat(firstInitial).concat(lastInitial).toUpperCase();
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "avatar",
                        style: (0, vue_2.normalizeStyle)({ background: _ctx.patprovider.avatarColor })
                    }, (0, vue_2.toDisplayString)(initials.value), 5),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.patprovider.lastName) + ", " + (0, vue_2.toDisplayString)(_ctx.patprovider.firstName), 1),
                        (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.patprovider.arn), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                    (_ctx.patprovider.phone)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                            _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, "Phone", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_8, [
                                (0, vue_2.createElementVNode)("a", {
                                    href: 'tel:' + _ctx.patprovider.phone + '',
                                    title: "Team Member Phone"
                                }, (0, vue_2.toDisplayString)(_ctx.patprovider.phone), 9, _hoisted_9)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.patprovider.mobile)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                            _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, "Cell", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_11, [
                                (0, vue_2.createElementVNode)("a", {
                                    href: 'tel:' + _ctx.patprovider.mobile + '',
                                    title: "Team Member Cell"
                                }, (0, vue_2.toDisplayString)(_ctx.patprovider.mobile), 9, _hoisted_12)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.patprovider.email)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                            _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, "Email:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)(_ctx.patprovider.email), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.patprovider.address && (_ctx.patprovider.address.street || _ctx.patprovider.address.city))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                            _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-map-marker" }, "Address:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_16, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.patprovider.address.street), 1),
                                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("br", null, null, -1)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.patprovider.address.city) + ", " + (0, vue_2.toDisplayString)(_ctx.patprovider.address.state) + " " + (0, vue_2.toDisplayString)(_ctx.patprovider.address.zip), 1)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.patprovider.npinumber)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, [
                            _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "NPI Number:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_18, (0, vue_2.toDisplayString)(_ctx.patprovider.npinumber), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (!_ctx.patprovider.npinumber && _ctx.patprovider.licenseNumber)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                            _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "License/Certificate #:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_20, (0, vue_2.toDisplayString)(_ctx.patprovider.licenseNumber), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.patprovider.fax)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                            _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "Fax:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_22, (0, vue_2.toDisplayString)(_ctx.patprovider.fax), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                        _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("span", { class: "bi bi-status" }, "Group:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_24, (0, vue_2.toDisplayString)(_ctx.patprovider.arn), 1)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action email-action",
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('email', _ctx.patprovider)); })
                    }, __spreadArray([], (_cache[12] || (_cache[12] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, null, -1),
                        (0, vue_2.createTextVNode)(" Email ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action sms-action",
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('sms', _ctx.patprovider)); })
                    }, __spreadArray([], (_cache[13] || (_cache[13] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment" }, null, -1),
                        (0, vue_2.createTextVNode)(" Text ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action call-action",
                        onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.$emit('call', _ctx.patprovider)); })
                    }, __spreadArray([], (_cache[14] || (_cache[14] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment bi-phone" }, null, -1),
                        (0, vue_2.createTextVNode)(" Call ", -1)
                    ])), true))
                ])
            ]));
        };
    }
});
